module.exports = __webpack_public_path__ + "static/media/merchatrade.560018ca.png";